/**
 * Orka V3 — Effort scale (Code Reference §3.6, PRD effort canon).
 * Used by DataAwareDatePicker, dashboard rails, future planning surfaces.
 */
export const DEFAULT_EFFORT_SCALE = Object.freeze([
  { key: 'empty',       label: 'Empty',       min: 0,  max: 0,   color: 'transparent', meaning: 'nothing planned' },
  { key: 'light',       label: 'Light',       min: 1,  max: 15,  color: '#3B82F6',     meaning: 'light day' },
  { key: 'balanced',    label: 'Balanced',    min: 16, max: 25,  color: '#22C55E',     meaning: 'balanced day' },
  { key: 'heavy',       label: 'Heavy',       min: 26, max: 35,  color: '#F59E0B',     meaning: 'heavy day' },
  { key: 'overloaded',  label: 'Overloaded',  min: 36, max: 45,  color: '#EF4444',     meaning: 'overloaded' },
  { key: 'doom',        label: 'Doom',        min: 46, max: 999, color: '#EF4444',     meaning: 'strongly discourage' },
]);

export function getEffortBucket(effort = 0) {
  const e = Number(effort) || 0;
  return (
    DEFAULT_EFFORT_SCALE.find((b) => e >= b.min && e <= b.max) ||
    DEFAULT_EFFORT_SCALE[0]
  );
}
